import i18next from "i18next";
import { IoChatbubblesOutline } from "react-icons/io5";

import { formatSupportDate, supportCategoryLabel } from "../utils";

import SupportStatusBadge from "../SupportStatusBadge";

import {
  CountBadge,
  EmptyState,
  TicketItem,
  TicketList,
  TicketMain,
  TicketMeta,
  TicketSide,
  TicketSubject,
  TicketTop,
} from "../style";

// Список заявок: «Ждём вашего ответа» выделен цветом, непрочитанные ответы — счётчиком и полужирной темой.
const SupportTicketList = ({ tickets, emptyText }) => {
  const { t } = i18next;

  if (!tickets.length) {
    return (
      <EmptyState>
        <IoChatbubblesOutline />
        {emptyText}
      </EmptyState>
    );
  }

  return (
    <TicketList>
      {tickets.map(ticket => {
        const isWaiting = ticket.status === "waiting_customer";
        const unread = Number(ticket.unread) || 0;

        return (
          <TicketItem key={ticket.id} to={`/support/${ticket.id}`} $waiting={isWaiting} $unread={unread > 0}>
            <TicketMain>
              <TicketTop>
                <span>{t("support_ticket_number", { number: ticket.number })}</span>
                {ticket.order_id && (
                  <span>
                    · {t("support_order")} {ticket.order_id}
                  </span>
                )}
                {ticket.category && <span>· {supportCategoryLabel(ticket.category)}</span>}
              </TicketTop>
              <TicketSubject $bold={unread > 0}>{ticket.subject}</TicketSubject>
              <TicketMeta>
                <span>
                  {t("support_updated_at")}: {formatSupportDate(ticket.last_message_at || ticket.created_at)}
                </span>
                {ticket.messages_count ? <span>{t("support_messages_count", { count: ticket.messages_count })}</span> : null}
              </TicketMeta>
            </TicketMain>

            <TicketSide>
              <SupportStatusBadge status={ticket.status} />
              {unread > 0 && <CountBadge title={t("support_unread_count", { count: unread })}>{unread}</CountBadge>}
            </TicketSide>
          </TicketItem>
        );
      })}
    </TicketList>
  );
};

export default SupportTicketList;
